import React from 'react';
import _ from 'lodash';
import { UploadMedia } from '../../../../../../common/components/common/upload-media';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import BlogPostMappedInfoComponent from './blog-post-mapped-info.component';
import BlogPostBasicInfoComponent from './blog-post-basic-info.component';



export const BlogPostComponent = ({
  
  id,
    selectedBlogPosts,
    socialProfileType,
    onFormItemChange,
    templates,
    tenantFunctions,
    handleFormItemChange,
    deleteSelectedFunctions,
    handleProductSearch,
    handleDeliverySearch,
    handleTierPriceSearch,
    handleCollectionPolicySearch,
    handleRewardPointSearch,
    handleDiscountSearch,
    handleVendorSearch,
    handleTopicSearch,
    handleModuleSearch,
    handleLearningPathSearch,
    handleCourseSearch,
    handleCollectionSearch,
    handleChannelSearch,
    handleCertificateSearch,
    handleAnnouncementSearch,
    handleCategorySearch,
    products,
    deliveries,
    collectionPolicies,
    tierPrices,
    rewards,
    discounts,
    organizationUnits,
    vendors,
    topics,
    modules,
    learningPaths,
    courses,
    collections,
    channels,
    certificates,
    announcements,
    categories,
    selectedFunctions,
    selectedTemplate,
    handleInnerFormChange,
    back,
    handleFormSubmit,
    changeImage,
    mediaFiles,
    accounts,
    deleteSelectedFile,
    getIsImageRecordDeletable,
    helpTopics
}: any) => {
  const handleInnerMediaFormChange: any = ({ field, value }: any) => {
        onFormItemChange({
            value: value.MediaFiles,
            field: 'MediaFiles',
            idx: '', //not used
        });
    };
    const tabItems = [
       {
        id:1,
        title:'Blog Post Information',
        component:<BlogPostBasicInfoComponent handleInnerFormChange={handleInnerFormChange}
        selectedBlogPosts={selectedBlogPosts}
        mediaFiles={mediaFiles}
        handleFormItemChange={handleFormItemChange}
        changeImage={changeImage}
        deleteSelectedFile={deleteSelectedFile}
        getIsImageRecordDeletable={getIsImageRecordDeletable}
         />,
    isVisible:true,
    },
      
 {
            id: 2,
            title: 'Media',
            component:
                <UploadMedia
                    handleInnerFormChange={handleInnerMediaFormChange}
                    mediaFilesList={selectedBlogPosts?.MediaMappings?.MediaFiles}
                    ownerTypeId={1007}
                    ownerId={id}
                    folderName={'BlogPost'}
                />,
            isVisible: true,
        },
       
        {
            id: 2,
            title: 'Mapped Entities',
            component: <BlogPostMappedInfoComponent
                templates={templates}
                tenantFunction={tenantFunctions}
                selectedFunctions={selectedFunctions}
                categories={categories}
                deleteSelectedFunctions={deleteSelectedFunctions}
                handleInnerFormChange={handleInnerFormChange}
                handleFormItemChange={handleFormItemChange}
                announcements={announcements}
                // certificates={certificates}
                channels={channels}
                // collections={collections}
                // courses={courses}
                // learningPaths={learningPaths}
                // modules={modules}
                topics={topics}
                // vendors={vendors}
                organizationUnits={organizationUnits}
                discounts={discounts}
                rewards={rewards}
                tierPrices={tierPrices}
                collectionPolicies={collectionPolicies}
                deliveries={deliveries}
                products={products}
                handleCategorySearch={handleCategorySearch}
                handleAnnouncementSearch={handleAnnouncementSearch}
                // handleCertificateSearch={handleCertificateSearch}
                handleChannelSearch={handleChannelSearch}
                // handleCollectionSearch={handleCollectionSearch}
                // handleCourseSearch={handleCourseSearch}
                // handleLearningPathSearch={handleLearningPathSearch}
                // handleModuleSearch={handleModuleSearch}
                handleTopicSearch={handleTopicSearch}
                // handleVendorSearch={handleVendorSearch}
                handleDiscountSearch={handleDiscountSearch}
                handleRewardPointSearch={handleRewardPointSearch}
                handleCollectionPolicySearch={
                    handleCollectionPolicySearch
                }
                handleTierPriceSearch={handleTierPriceSearch}
                handleDeliverySearch={handleDeliverySearch}
                handleProductSearch={handleProductSearch}
                accounts={accounts}
            />,
            isVisible: true,
        },

    ]

    return (
        <>



            <TabContainer tabItems={tabItems} />



            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>

        </>
    );
};
export default BlogPostComponent;
